// JavaScript Document
//components/signs/Signs.js
import React from 'react';
import { TextField, MenuItem, AppBar, Box, Tabs, Tab, DialogTitle, DialogContent, DialogActions, Button} from '@material-ui/core';
import PropTypes from 'prop-types';
import EditFields from './Columns';
import EditFilters from './Filters';
import EditSort from './Sort';


//tabs
function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-auto-tabpanel-${index}`}
        aria-labelledby={`scrollable-auto-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box>
            {children}
          </Box>
        )}
      </div>
    );
  }//`
  
        
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };
        
  function a11yProps(index) {
    return {
      id: `scrollable-auto-tab-${index}`,
      'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
  }
  //end tabs


export default function ViewEditor(props) {
    //inherit variables from parent
    const {view, onSave, onCancel, user, organization, fields} = props;
    //copy of the view into new state variable
    const [myView, setMyView] = React.useState(view);
    //currently selected tab number
    const [tabNum, setTabNum] = React.useState(0);
    //saving state
    const [saving, setSaving] = React.useState(false);
    //compile sharing options
    const sharing = () => {
        let share = 
        [
        {
            name : 'private',
            description : 'Only for me'
        },
        {
            name : 'group',
            description : 'People in '+organization.name
        }];
        if(user.usergroup === 1) share.push(
        {
            name : 'public',
            description : 'Everyone'
        });
        return share;
    };
    //compile editor dialog title
    const editorTitle = () => {
        if(myView.id){
            return ['Edit', myView.lv_name, 'view'].join(' ');
        }
        return 'New View';
    }

    //when the name or sharing is changed
    const handleChangeValue = (e) => {
        let newView = Object.assign({}, myView);
        newView[e.target.name] = e.target.value;
        setMyView(newView);
    }

    //changing the tab
    const handleChangeTab = (event, newValue) => {
		setTabNum(newValue);
	};

    //save button clicked
    const handleSave = (e) => {
        setSaving(true);
        onSave(myView);
    }
    //describe the sharing level
    const describeSharing = (level) => {
        return [level.name.substring(0, 1).toUpperCase()+level.name.substring(1), level.description].join(': ');
    }

    //render the dialog content
    return (
    <div>
        <DialogTitle id="editor-title">{editorTitle()}</DialogTitle>
        <DialogContent>
            <Box display="flex">
            <TextField
                id="view-name"
                label="View Name"
                name='lv_name'
                value={myView.lv_name}
                onChange={handleChangeValue}
                fullWidth
            />
            <TextField
                id="view-sharing"
                label="Sharing"
                name='sharing'
                value={myView.sharing}
                onChange={handleChangeValue}
                fullWidth
                select
            >
                {sharing().map((level, i) => (
                    <MenuItem key={i} value={level.name}>{describeSharing(level)}</MenuItem>
                ))}
            </TextField>
            </Box>
        </DialogContent>
        <AppBar position="static" color="default">
			<Tabs
				value={tabNum}
				onChange={handleChangeTab}
				indicatorColor="primary"
				textColor="primary"
				variant="scrollable"
				scrollButtons="auto"
				aria-label="view tabs"
			>
				<Tab label="Columns" {...a11yProps(0)} />
				<Tab label="Filter" {...a11yProps(1)} />
				<Tab label="Sort" {...a11yProps(2)} />
			</Tabs>
		</AppBar>
        <DialogContent>
            <TabPanel value={tabNum} index={0}>
                <EditFields view={myView} fields={fields} setView={setMyView} />
		    </TabPanel>
            <TabPanel value={tabNum} index={1}>
                <EditFilters view={myView} fields={fields} setView={setMyView} />
            </TabPanel>
            <TabPanel value={tabNum} index={2}>
                <EditSort view={myView} fields={fields} setView={setMyView} />
            </TabPanel>
        </DialogContent>
        <DialogActions>
            <Button onClick={onCancel}>Cancel</Button>
            <Button onClick={handleSave} disabled={Boolean(myView.errors) || saving}>{saving ? 'Saving...' : 'Save'}</Button>
        </DialogActions>
    </div>
    );
}
